<script>
    import app from "../stores/app";
    import {PAYMENT_TYPES, ROUTE_TYPE, TRANSFER_STATUSES} from "../lib/constants";
    import {formatDate} from "../lib/lib";

    export let reservation;
    export let transfer;

    let reservationLink = `${$app.department_reservation_url}/${transfer.department.link_code}/reservation/${reservation.hash}`;
</script>

{#if reservation}
    <div class="panel panel-default mb-5">
        <div class="panel-heading">
            Reservation Details
        </div>
        <div class="panel-body panel-pad py-2">
            <table class="table table-list">
                <tbody>
                {#if reservation.agent_email}
                    <tr>
                        <td colspan="2" class="px-0 py-2">
                            <div class="small">Agent email</div>
                            {reservation.agent_email}
                        </td>
                    </tr>
                {/if}
                <tr>
                    <td class="px-0 py-2">
                        <div class="d-flex gap-2">
                            <div class="w-50">
                                <div class="small">Reference code</div>
                                {reservation.ref || ''}
                            </div>
                            <div class="w-50">
                                <div class="small">Order id</div>
                                {reservation.order_id || ''}
                            </div>
                        </div>
                    </td>
                </tr>
                {#if reservation.transaction_id}
                    <tr>
                        <td class="px-0 py-2">
                            <div class="small">Transaction id</div>
                            {reservation.transaction_id || ''}
                        </td>
                    </tr>
                {/if}
                <tr>
                    <td class="px-0 py-2">
                        <div class="d-flex gap-2">
                            <div class="w-33">
                                <div class="small">Price</div>
                                {#if reservation.price}
                                    € {reservation.price}
                                {/if}
                            </div>
                            <div class="w-33">
                                <div class="small">Payment</div>
                                {#if reservation.payment}
                                    € {reservation.payment}
                                {/if}
                            </div>
                            <div class="w-33">
                                <div class="small">Payment type</div>
                                {PAYMENT_TYPES[reservation.payment_type]}
                            </div>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td class="px-0 py-2">
                        <div class="small">Reservation link</div>
                        <a href={reservationLink} class="d-block" target="_blank">
                            {reservationLink}
                        </a>
                    </td>
                </tr>
                {#each reservation.routes as route}
                    <tr>
                        <td class="px-0 py-2" class:text-gray={route.transfer_id == transfer.id}>
                            {#if route.route_type == ROUTE_TYPE.TOUR}
                                {#if route.transfer_id != transfer.id}
                                    <a href="/app/tour/{route.transfer_id}"
                                       class="btn-link d-block w-100 fw-semibold" target="_blank">
                                        {route.tour_name}
                                    </a>
                                {:else}
                                    <div class="fw-semibold">{route.tour_name}</div>
                                {/if}
                            {:else}
                                {#if route.transfer_id != transfer.id}
                                    <a href="/app/transfer/{route.transfer_id}"
                                       class="btn-link d-block w-100 fw-semibold" target="_blank">
                                        {route.pickup_name} → {route.drop_name}
                                    </a>
                                {:else}
                                    <div class="fw-semibold">{route.pickup_name} → {route.drop_name}</div>
                                {/if}
                            {/if}
                            {#if route.transfer_at}
                                <div>{formatDate(route.transfer_at, 'd-m-y H:i')}</div>
                            {:else}
                                <div class="text-danger">Date not set</div>
                            {/if}
                            {#if route.status_id != null}
                                <div>
                                    {TRANSFER_STATUSES[route.status_id]}
                                </div>
                            {/if}
                        </td>
                    </tr>
                {/each}
                </tbody>
            </table>
        </div>
    </div>
{/if}